module.exports = __webpack_public_path__ + "static/media/editwhite.24cc62d5.svg";